<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="banner alb">
        <div class="bannerCont wow animated fadeInLeft">
          <h3>{{$t('app')}}</h3>
          <p>{{ $t('banner.slogan')}}</p>
          <button @click="cToParent()">{{ $t('banner.download')}}</button>
        </div>
        <div class="bannerImg wow animated fadeInRight">
          <img src="../assets/banner.png"/>
        </div>
      </div>
</template>
<script>
export default {
  methods: {
    cToParent () {
      // 第一个参数是事件名，第二个参数是要传递的数据
      event.stopPropagation()
      this.$emit('banner-event')
    }
  }
}
</script>
<style scoped>
  .bannerCont h3{font-size: 40px;font-weight: bold;color: #3278FD;}
  .bannerCont p{margin: 10px 0;font-size: 36px;font-weight: bolder;color: #333;}
  .bannerCont button{border: 0;width: 200px;height: 40px;border-radius: 20px;background-color: #3278FD;color: #fff;}
  .bannerImg{width: 40%;max-width: 550px;}
  @media (max-width: 800px) {
    .bannerCont h3{font-size: 26px;}
    .bannerCont p{font-size: 20px;}
    .bannerCont button{height: 30px;width: 150px;}
    .bannerImg{width: 60%;}
  }
</style>
